import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import { ThemeProvider } from './hooks/useTheme'
import { ToastProvider } from './hooks/useToast'
import { FontSizeProvider } from './hooks/useFontSize'
import ErrorBoundary from './components/ErrorBoundary'
import App from './App'
import { initSentry } from './lib/sentry'
import { initAnalytics } from './lib/analytics'
import { installPreloadErrorRecovery } from './lib/preload-recovery'
// Side-effect import: bootstraps i18next + detection + the HTTP backend
// so useTranslation() works anywhere in the tree. Pulled in here rather
// than lazily inside App so the locale is decided before first paint —
// otherwise the initial render flashes English then re-renders into the
// user's actual language a tick later.
import './i18n'
import './index.css'

// Install the stale-chunk auto-reload before anything else so a chunk
// 404 during initial route hydration recovers cleanly instead of
// landing in the ErrorBoundary fallback.
installPreloadErrorRecovery()
// Init Sentry before React mounts so errors during initial render are
// captured. No-op when VITE_SENTRY_DSN is unset.
initSentry()
// Init PostHog likewise — the helpers in lib/analytics no-op until this
// has run, and forever when VITE_POSTHOG_KEY is unset (dev / test / CI).
initAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
          <FontSizeProvider>
            <ToastProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </ToastProvider>
          </FontSizeProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
)
